import { Box, Divider } from "@chakra-ui/react";
import CardTitleSkeleton from "./CardTitleSkeleton";

const CardSkeleton = ({ children, ...props }) => {
    return (
        <Box
            p={'24px'}
            bg={'semantic.100'}
            border={'1px solid'}
            borderColor={'neutral.200'}
            borderRadius={'8px'}
            {...props}
        >
            <CardTitleSkeleton />
            <Divider my={'24px'} />
            {children}
        </Box>
    );
};

export default CardSkeleton;
